import { Link } from "@tanstack/react-router";
import { setUi } from "../../lib/uiStore";

/** Вводная строка раздела настроек: одна фраза и ссылка на главу справки, где всё подробно. */
export function Intro({ children, chapter }: { children: string; chapter: string }) {
  return (
    <p className="mb-5 text-[13px] leading-[19px] text-sub">
      {children}{" "}
      <Link
        to="/help/$chapterId"
        params={{ chapterId: chapter }}
        onClick={() => setUi({ settings: null })}
        className="font-semibold whitespace-nowrap text-accent-ink underline decoration-accent-line underline-offset-2 hover:decoration-current"
      >
        Как это работает
      </Link>
    </p>
  );
}
